import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { PanelModule } from 'primeng/panel';
import { SharedModule } from '../../../shared/shared.module';
import { AddCustomerModule } from '../../add/add-customer.module';
import { IndividualSearchComponent } from './individual-search.component';

@NgModule({
    declarations: [
        IndividualSearchComponent
    ],
    providers: [],
    imports: [
        AddCustomerModule,
        CalendarModule,
        InputMaskModule,
        PanelModule,
        SharedModule
    ],
    exports: [
        IndividualSearchComponent
    ]
})

export class IndividualSearchModule {}
